import { useContext, useState } from 'react';
import { cardContentClasses, Typography } from '@mui/material';
import moment from 'moment';

import Components from 'Lib/constants/security/components';
import NotePermissions from 'Lib/constants/security/components/notes';
import SidebarContext from 'Lib/contexts/SidebarContext';
import DeleteDialog from 'Lib/muiComponents/dialog/DeleteDialog';

import Card from '../../common/cards/Card';

export const Letter = ({ letter, file, isDeleting, handleDelete, handleDownload, toggleCompose }) => {
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const { hasPermission } = useContext(SidebarContext);

    const LetterHeader = () => <Typography sx={{ fontWeight: 'medium' }}>{file.title}</Typography>;

    const DeleteModal = ({ isDeleting, toggle, open, handleDelete, letter }) => {
        return (
            <DeleteDialog title="Delete Letter" buttonText="Delete Letter" open={open} isDeleting={isDeleting} toggle={toggle} onDelete={() => handleDelete(letter)}>
                <Typography>Are you sure you want to delete this letter?</Typography>
            </DeleteDialog>
        );
    };

    const actions = () => {
        let actions;
        if (hasPermission(Components.Notes, NotePermissions.UpdateNotes)) {
            actions = [
                { label: 'Email', onClick: () => toggleCompose({ ...file, ...letter }) },
                { label: 'Download', onClick: handleDownload },
                {
                    label: 'Preview',
                    onClick: () => window.open(`/api/manager/letters/${letter.letterID}/preview`, '_blank')
                },
                { label: 'Delete', onClick: () => setDeleteModalOpen(true) }
            ];
        }

        return actions;
    };

    const localDateTime = moment.utc(file.dateTimeCreated).tz(moment.tz.guess());

    return (
        <Card
            title={<LetterHeader />}
            icon="more_vert"
            sx={{ mb: 4, py: 2, px: 4 }}
            actions={actions}
            Footer={{
                items: [
                    {
                        icon: 'calendar_month',
                        content: () => (
                            <Typography variant="caption">
                                {localDateTime.isSame(moment(), 'day')
                                    ? 'Today'
                                    : localDateTime.isSame(moment().subtract(1, 'day'), 'day')
                                    ? 'Yesterday'
                                    : localDateTime.format('MMM D, YYYY')}
                            </Typography>
                        )
                    },
                    {
                        icon: 'schedule',
                        content: () => <Typography>{localDateTime.format('h:mm a z')}</Typography>
                    }
                ],
                sx: { [`& .${cardContentClasses.root}`]: { p: '0 !important' } }
            }}
        >
            <DeleteModal open={deleteModalOpen} isDeleting={isDeleting} toggle={() => setDeleteModalOpen(!deleteModalOpen)} handleDelete={handleDelete} letter={letter} />
        </Card>
    );
};
